import React, { Component } from 'react';
import Autosuggest, { ItemAdapter } from '../../modules/autosuggest/Autosuggest.js';
import Geocode from "react-geocode";

import Lang from '../../languages';
import Config from '../../config';

Geocode.setApiKey(Config.googleMapsToken);
Geocode.enableDebug();
Geocode.setRegion("es");
Geocode.setLocationType("APPROXIMATE");

class AutoAdapter extends ItemAdapter {
 renderItem(item) {
  return (
   <div className="repo">
    <div>
     <div className="repo-title">{item.formatted_address}</div>
    </div>
   </div>
  )
 }
}

AutoAdapter.instance = new AutoAdapter();

class GeoAutosuggest extends Component {
 constructor(props) {
  super(props);

  this.doChange = this.doChange.bind(this);
  this.doSearch = this.doSearch.bind(this);
  this.doSelect = this.doSelect.bind(this);
  this.toggleModal = this.toggleModal.bind(this);

  this.state = {
   searchValue: '',
   searchResults: [],
   searchMessage: '',
   createClient: false
  }
 }

 doSearch(search) {
  if (search !== '') {
   const sp = search.lastIndexOf('/');
   if (sp >= 0) search = search.substring(sp + 1);
   this.setState({ searchMessage: Lang[this.props.session.language].Autosuggest.inProgress });

   Geocode.fromAddress(search).then(searchResults => {

    let searchMessage

    if (searchResults.results.length === 0) {
     searchMessage = Lang[this.props.session.language].Autosuggest.noResults
    }

    this.setState({ searchResults: searchResults.results, searchMessage });
   }, err => {
    if (err.message.includes('ZERO_RESULTS')) {
     this.setState({
      searchResults: [],
      searchMessage: Lang[this.props.session.language].Autosuggest.noResults
     })
    } else {
     this.setState({
      searchResults: null,
      searchMessage: Lang[this.props.session.language].Autosuggest.errMessage(err.message)
     })
    }

   })


  } else {
   this.setState({
    searchResults: null,
    searchMessage: Lang[this.props.session.language].Autosuggest.minChars
   });
  }
 }


 doChange(value) {
  this.setState({ searchValue: value })
 }

 doSelect(place) {
  if (place !== null && place.formatted_address !== undefined) {
   this.props.handleCallback(place);
   this.setState({
    searchValue: place.formatted_address,
    searchResults: [],
    searchMessage: ''
   });
  }
 }

 toggleModal() {
  this.setState({ createClient: !this.state.createClient });
 }

 render() {
  return (
   <Autosuggest
    className={this.props.className}
    value={this.props.value}
    showToggle={false}
    searchDebounce={500}
    allowDuplicates={false}
    closeOnCompletion={true}
    datalist={this.state.searchResults}
    datalistOnly={false}
    datalistPartial={false}
    datalistMessage={this.state.searchMessage}
    onDatalistMessageSelect={() => this.toggleModal()}
    itemReactKeyPropName="ID"
    itemValuePropName="name"
    placeholder={this.props.placeholder ? this.props.placeholder : ''}
    onSearch={this.doSearch}
    onChange={this.doChange}
    onSelect={this.doSelect}
    itemAdapter={AutoAdapter.instance} />
  )
 }
}

export default GeoAutosuggest;



// WEBPACK FOOTER //
// ./websources/components/GeoAutosuggest/index.js